// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__LdI5K","text":"Loading_text__1Zts1"};